import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';
import { RewardsOffersSchema } from '@lotta/shared/types-lottery-schemas';

export type GetRewardOffersParams = Static<typeof GetRewardOffersParamsSchema>;
export const GetRewardOffersParamsSchema = Type.Object(
  {
    retailUnit: Type.String({ minLength: 2, maxLength: 2 }),
  },
  { additionalProperties: false, $id: 'GetRewardOffersParamsSchema' }
);

export type GetRewardOffersResponse = Static<typeof GetRewardOffersResponseSchema>;
export const GetRewardOffersResponseSchema = Type.Object(
  {
    offers: RewardsOffersSchema,
  },
  { additionalProperties: false, $id: 'GetRewardOffersResponseSchema' }
);
